import React, { ReactElement } from 'react';
import useFeatureToggleService from './featureToggleService';

export default function PropertiesPageToggle(
  props: {
    children: ListOrSingle<ReactElement>,
  },
) {

  const featureToggleService = useFeatureToggleService();

  if (featureToggleService.isPropertiesPageCustomizationEnabled()) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<>{props.children}</>);
  } else {
    return null;
  }
}
